export default __webpack_public_path__ + "static/media/18.48bdf61e.svg";